import React from 'react';
import { Switch, Route, RouteProps } from 'react-router-dom';
import { LazyArtistHeader } from '../Artist';
import { LazyTeamHeader } from '../../features/TeamHeader';
import { LazySubscribeHeader } from '../../features/Subscribe';
import { LazyUserSettingsHeader } from '../../features/UserSettingsHeader';
import { useCurrentUser } from '../../shared/currentUser';
import { ErrorBoundary, createLogger } from '../../features/errorLogging';
import { Header, FlyOutToggle } from '../../shared/components/Header';

const logger = createLogger('Header');
const fallback = (
  <Header>
    <FlyOutToggle avatar={null} name={null} />
  </Header>
);

function HeaderRoute(props: RouteProps) {
  const currentUser = useCurrentUser();

  // don't render header if logged out
  if (!currentUser) {
    return null;
  }

  return (
    <ErrorBoundary logger={logger} fallback={fallback}>
      <React.Suspense fallback={fallback}>
        <Route {...props} />
      </React.Suspense>
    </ErrorBoundary>
  );
}

export function HeaderRouter() {
  return (
    <Switch>
      <Route path="/team/accept-invite" render={() => null} />
      <HeaderRoute
        path={['/team/:teamType/:teamId', '/activity/:teamType/:teamId']}
        component={LazyTeamHeader}
        key="team"
      />
      <HeaderRoute
        path="/subscribe/artist/:artistId"
        component={LazySubscribeHeader}
        key="subscribe"
      />
      <HeaderRoute
        path="/artist/:artistId"
        component={LazyArtistHeader}
        key="artist"
      />
      <HeaderRoute
        path="/settings"
        component={LazyUserSettingsHeader}
        key="settings"
      />
    </Switch>
  );
}
